import React,{ useEffect } from "react";
import { useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Table from "../../components/admin/Table";
import { shoppingPartnersList } from "../../slices/ShoppingPartnersSlices";
import { useDispatch } from "react-redux";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import { CamelToSentanceCase, startDownload, ToSelectOption} from "../../Utils/utils/CommanFnc";
import { reset } from "../../slices/UserSlice";
import SelectBox from "../../components/admin/SelectBox";
import { useForm, Controller } from "react-hook-form";
import { CityByState, getAllState } from "../../slices/InitialDataSlice";
import { downloadVendorReport } from "../../services/reports";
import { Loading } from "../../components/Loading";

export function List() {
  const data = useSelector((state) => state.shoppingPartners)
  
  const loading = useSelector( (state) => state.shoppingPartners.loading )

  const initialData = useSelector( (state) => state.initialData )

  const [businessData, setBusinessData] = useState([]);
  
  const [columsData, setColumsData] = useState([]);
  
  const [searchParams, setSearchParams] = useSearchParams()
  
  const queryString = Object.fromEntries([...searchParams.entries()])
  
  const [icon, setIcon] = useState("")

  const [states, setStates] = useState([])
  
  const [cities, setCities] = useState([])

  const [pincodes, setPincodes] = useState([])

  const [areaList, setAreaList] = useState([])

  const [beats, setBeats] = useState([])

  const [downloadLoading, setDownloadLoading] = useState(false)

  // const [serachString, setSearchString] = useState({
  //   searchString:queryString.searchString?queryString.searchString:''
  // })
  
  const [defaultParams, setDefaultParams] = useState({
    pageLength:defaultConfig.defaultLimit,
    page:1
  })
  
  const params = useParams()
  
  const dispatch = useDispatch()  
  
  const columns =  useMemo(()=>{
    let col  = [
      {
        name:`${defaultConfig.partners[params.type]['label']}`,
        selector: (row) => row?.userDetails?.shopName,
        sortable:true,
        center:true
      },
      {
        name: `${defaultConfig.partners[params.type]['label']} Code`,
        selector: (row) => row?.vendorCode,
        sortable:true,
        center:true
      },
      // {
      //   name: "E-Mail",
      //   selector: (row) => row.email,
      //   sortable: true,
      //   center: true,
      // },
      {
        name: "City/District",
        selector: (row) => row.cityName,
        sortable: true,
        center: true,
        cell: (row) => (
          <>{CamelToSentanceCase(row.cityName) || '--'}</>
        )
      },
      {
        name: "Pincode/Beat",
        selector: (row) => row?.beatPincode || '--',
        sortable: true,
        center: true,
        cell: (row) => (
          <>
            {`${row.beatPincode} (${row.beatName})`}
          </>
        )
      },
      {
        name: "State",
        selector: (row) => row.stateName,
        sortable: true,
        center: true,
        cell: (row) => (
          <>{CamelToSentanceCase(row.stateName) || '--'}</>
        )
      },
      {
        name:"Status",
        selector: (row) => row.status,
        sortable:false,
        center:true,
        cell: (row) => (
          <>
            <i className={`far fa-dot-circle fa-w-16 ${row.status === 'active'?'text-success':'text-muted'}`} aria-hidden="true"></i>
            &nbsp;
            {CamelToSentanceCase(row.status) || 'Inactive'}
          </>
        )
      },
      {
        name: "Created By",
        selector: (row) => row.cretedByUser,
        sortable:false,
        center:true,
      },
      {
        name: "Action",
        button: false,
        center: true,
        cell: (row) => (
          <>
            <Link to={{
              pathname: `/add-shopping-partner/${params.type}/${row._id}`,
              search: "",
              hash: "",
            }} replace 
            state={defaultParams} className="sidebar-link" data-toggle="tab">
                {" "}
                <i className="fa fa-edit"></i>{" "}
              </Link>
          </>
          // <Link to={`/add-users/${row._id}`} onClick={} className="sidebar-link" data-toggle="tab">
          //   {" "}
          //   <i className="fa fa-edit"></i>{" "}
          // </Link>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ];
    if(defaultConfig['parentUserLabel'][params.type]){
      col.unshift({
        name:defaultConfig['parentUserLabel'][params.type],
        selector: (row) => row.parentUser,
        sortable: true,
        center: true,
      })
    }
    return col
  },[defaultParams, params.type])
  
  const type = params.type
  
  const {
    register,
    control,
    setValue,
    getValues,
    handleSubmit,
  } = useForm({
    mode: "onBlur",
  });

  useEffect(()=>{
    if(Object.keys(queryString).length === 0){
      dispatch(shoppingPartnersList({data:defaultParams, type}))
    }else{
      setDefaultParams({...defaultParams, ...queryString}) 
      dispatch(shoppingPartnersList({data:defaultParams, type}))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch, type]);

  useEffect( ()=>{
    setBusinessData(data)
    return () => dispatch(reset())
  },[data, dispatch])

  useEffect( () =>{
    setColumsData(columns)
  },[columns, defaultParams])

  useEffect( () => {
    setIcon(type === "distributors"?"fa fa-handshake":"fa fa -store")
  },[type])

  useEffect( () => {
    dispatch(getAllState())
  }, [dispatch])

  useEffect( () => {
      const stateList = [];
      initialData?.StateList?.forEach(item => {
        if(item._id !== ""){
          stateList.push({
            value : item._id,
            label: CamelToSentanceCase(item.name)
          })
        }
      })
      setStates(stateList)
  }, [initialData.StateList])

  useEffect( () => {
    const cityList = [];
    initialData?.CitiesList?.forEach(item => {
      if(item._id !== ""){
        cityList.push({
          value : item._id,
          label: CamelToSentanceCase(item.name)
        })
      }
    });
    setCities(cityList)
  }, [initialData?.CitiesList])

  const onSearch = async (data) => { 
    if(!data.isStartRetailer) {
      var { isStartRetailer, ...searchData } = data
    } else {
      var searchData = { ...data }
    }
    let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...searchData})
    setDefaultParams({...params, ...data})
    dispatch(shoppingPartnersList({data: params, type}))
  }

  const onStateChange = (callback, opt) => {
    setValue('cityId', '')
    setValue('pincodeId', '')
    setValue('beatId', '')
    if(opt?.value){
      dispatch(CityByState(opt?.value || ''))
    }
    callback(opt?.value || '')

  }
  
  const onCityChange = (callback, opt) => {
    const stateAreaList = initialData?.CitiesList?.find( (item) => item._id ===  opt?.value )
    const pincodeList = stateAreaList?.areas?.map( (item) => {
      return {
        value : item._id,
        label: item.pincode
      }
    })
    setAreaList(stateAreaList?.areas || [])
    setPincodes(pincodeList || [])
    callback(opt?.value || '')
  }

  const onPincodeChange = (callBack, opt) => {
    const beatsList = areaList?.filter( (item) => item.pincode ===  (opt?.label || ''))
      setBeats(() => {
        return ToSelectOption(beatsList, {value: "_id", label: "name"}) 
      })
      callBack(opt?.value || '')   
  }

  const resetSearch = () => {
    let params = {pageLength: defaultConfig.defaultLimit, page:1}
    setSearchParams(params)  
    setDefaultParams(params)
    window.location.reload(true)
  }

  // const searchInt = () => {
  //     let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
  //     setSearchParams(params)  
  //     setDefaultParams(params)
  //     dispatch(shoppingPartnersList({data:params, type}))
  // }

  const setPaginationData = (paginationData) =>{
    const params = {...defaultParams, page:paginationData.page, pageLength:paginationData.pageLength}
    setDefaultParams(params)
    setSearchParams(params)
  }

  const downloadReport = async () => {
    setDownloadLoading(true)
    const searchString = getValues()
    searchString.type = type;
    const excelData = await downloadVendorReport(searchString)
    const fileName = `report-${defaultConfig.partners[params.type]['label']}.xlsx`
    startDownload(excelData, fileName)
    setDownloadLoading(false)
  }

  return (
    <React.Fragment>
      { downloadLoading? <Loading/>: ''}
      <div className="revenue-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <div className="card table-card">
              <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                <h4 className="card-title mB25 mb-sm-0">
                    <i className={`${icon}`}></i>  {defaultConfig.partners[params.type]['label']}  
                </h4>
              </div>
              <div className="row m-3">
                  <div className="col-sm-8">
                    <form onSubmit={handleSubmit(onSearch)}>
                      <div className="row">
                        <div className="col-sm-3 p-0">
                            <div className="form-group mb-3">
                              <input
                                type="text"
                                {...register("searchString")}
                                //defaultValue={serachString.searchString}
                                //onChange={setValue}
                                placeholder="Search..."
                                className="form-control"
                              />
                            </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="stateId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={states}
                                  isClearable={true}
                                  placeholder="Select State"
                                  onChange={(opt) => onStateChange(onChange, opt)}
                                  value={states.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="cityId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={cities}
                                  placeholder="Select City"
                                  isClearable={true}
                                  onChange={(opt) => onCityChange(onChange, opt)}
                                  value={cities.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="pincodeId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={pincodes}
                                  placeholder="Select Pincode"
                                  isClearable={true}
                                  onChange={(opt) => onPincodeChange(onChange, opt)}
                                  value={pincodes?.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group mb-3">
                            <Controller
                              control={control}
                              name="beatId"
                              defaultValue={''}
                              render={({ field: { value, onChange } }) => (
                                <SelectBox
                                  options={beats}
                                  placeholder="Select Beats"
                                  isClearable={true}
                                  onChange={(opt) => onChange(opt?.value || '')}
                                  value={beats.find(
                                    (option) => option.value === value
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                        &nbsp;&nbsp;
                        <div className="col-sm-3 p-0">
                          <div className="form-group pt-3 mb-0">
                            <label htmlFor="card-number" className="additionalBusiness">
                              <input
                                width=""
                                type="checkbox"
                                id="card-number"
                                {...register("isStartRetailer")}
                                //checked={show}
                                //onClick={(e) => showHideAdditionalPlace(e)}
                                placeholder={`Star ${defaultConfig.partners[params.type]['label']}`}
                                className="additionalBusiness-input"
                              />
                              {`Star ${defaultConfig.partners[params.type]['label']}`}
                            </label>
                          </div>
                        </div>
                        <div className="col-sm-2 col-1 p-0 ml-1">
                           <button type="submit" className="btn btn-primary btn-lg">
                             <i className="fa fa-search"></i>
                           </button>
                           &nbsp;
                           <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                             <i className="fas fa-undo"></i>
                           </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="col-sm-4 p-0 text-right">
                    <Link
                        to={{
                          pathname: `/add-shopping-partner/${params.type}`,
                          search: "",
                          hash: "",
                        }} replace 
                        state={defaultParams}
                        className="button blue-button btn-success"
                        data-toggle="tab"
                      >
                        <i className=" fa fa-plus" />
                        {" "}
                        Add {defaultConfig.partners[params.type]['label']}{" "}
                    </Link>
                    <div className="col-md-12 text-right pr-0">
                      <button onClick={downloadReport} className="btn btn-success"> 
                          <i className="fa fa-download"></i> Download Report 
                      </button>
                    </div>
                  </div> 
              </div>
              <Table 
                totalCount={businessData.totalCount}
                type={params.type}
                data={businessData.list} 
                columns={columsData} 
                dataLoadFnc={shoppingPartnersList} 
                extraConfig = {defaultParams}
                loading={loading}  
                callBack={setPaginationData}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
